$(function () {
    if ($("div").hasClass("cart__check")){
        $(".cart__checkout-button").attr("disabled", "disabled");
        $("#cart__check").click(function () {
            if ($(this).prop("checked") == false){
                $(".cart__checkout-button").attr("disabled", "disabled");
                document.getElementById("message").style.display = "";
            } else {
                $(".cart__checkout-button").removeAttr("disabled");
                document.getElementById("message").style.display = "block";
            }
        });
    }
});